import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { company } from "../mock";
import TopBar from "./navbar/TopBar";
import DesktopNav from "./navbar/DesktopNav";
import MobileMenu from "./navbar/MobileMenu";
import { useScrollThreshold } from "../hooks/useScrollThreshold";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const scrolled = useScrollThreshold(20);

  const closeMenu = () => setOpen(false);
  const toggleMenu = () => setOpen((prev) => !prev);

  return (
    <header
      id="home"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-white/80 backdrop-blur-sm"
      }`}
    >
      <TopBar />

      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2">
          <img
            src={company.logo}
            alt={`${company.name} logo`}
            className="h-12 lg:h-14 w-auto object-contain"
            style={{ maxWidth: 260 }}
          />
        </a>

        <DesktopNav />

        <button onClick={toggleMenu} className="lg:hidden p-2 text-brand" aria-label="menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && <MobileMenu onClose={closeMenu} />}
    </header>
  );
}
